import React, { useEffect, useState } from "react";
import { Download } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { api, API, getToken } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Totals, LedgerTable } from "@/components/tds/LedgerTable";
import { cn } from "@/lib/utils";

const PERIODS = ["daily", "weekly", "monthly", "quarterly", "yearly", "fy", "custom"];

export function TdsReports() {
  const { can } = useAuth();
  const [period, setPeriod] = useState("monthly");
  const [cat, setCat] = useState("");
  const [from, setFrom] = useState(new Date().toISOString().slice(0, 8) + "01");
  const [to, setTo] = useState(new Date().toISOString().slice(0, 10));
  const [rep, setRep] = useState(null);
  const params = { period, category: cat || undefined, ...(period === "custom" ? { date_from: from, date_to: to } : {}) };
  useEffect(() => {
    api.get("/tax/report", { params }).then(({ data }) => setRep(data)).catch(() => setRep(null));
  }, [period, cat, from, to]); // eslint-disable-line react-hooks/exhaustive-deps
  const exp = (fmt) => {
    const qs = new URLSearchParams({ ...Object.fromEntries(Object.entries(params).filter(([, v]) => v)), fmt, token: getToken() });
    window.open(`${API}/tax/report/export?${qs}`, "_blank");
  };
  return (
    <div data-testid="tds-reports">
      <div className="mb-3 flex flex-wrap items-center gap-2">
        <div className="flex flex-wrap rounded-lg border border-border p-1 text-sm">
          {PERIODS.map((p) => <button key={p} onClick={() => setPeriod(p)} data-testid={`tds-period-${p}`}
            className={cn("rounded-md px-3 py-1 capitalize", period === p ? "bg-primary text-primary-foreground" : "hover:bg-accent")}>{p === "fy" ? "Financial Year" : p}</button>)}
        </div>
        {period === "custom" && <><Input type="date" className="w-40" value={from} onChange={(e) => setFrom(e.target.value)} data-testid="tds-from" /><Input type="date" className="w-40" value={to} onChange={(e) => setTo(e.target.value)} data-testid="tds-to" /></>}
        <select value={cat} onChange={(e) => setCat(e.target.value)} className="h-9 rounded-md border border-input bg-background px-2 text-sm" data-testid="tds-report-category">
          <option value="">All payees</option><option value="dp">Delivery Partners</option><option value="franchise">Franchise Partners</option>
        </select>
        {rep && <span className="text-xs text-muted-foreground">{rep.from} → {rep.to}</span>}
        {can("tax.download") && <div className="ml-auto flex gap-2">{["excel", "csv", "pdf"].map((f) => (
          <Button key={f} size="sm" variant="outline" onClick={() => exp(f)} data-testid={`tds-export-${f}`}><Download className="mr-1 h-4 w-4" />{f.toUpperCase()}</Button>))}</div>}
      </div>
      {rep && <><Totals s={rep.summary} /><LedgerTable rows={rep.rows} testId="tds-report-table" /></>}
    </div>
  );
}
